import { render } from "./CurrPhoto.vue?vue&type=template&id=cf93fdee&scoped=true"
import script from "./CurrPhoto.vue?vue&type=script&lang=js"
export * from "./CurrPhoto.vue?vue&type=script&lang=js"

import "./CurrPhoto.vue?vue&type=style&index=0&id=cf93fdee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf93fdee"]])

export default __exports__